<script>
import HomeStudentDashboardComponent from '../../features/dashboards/HomeStudentDashboardComponent';
import ModalStudentInfoView from '../../../account/views/ModalStudentInfoView';
import ModalStudentSimulatorView from '../../../account/views/ModalStudentSimulatorView';

export default {
  name: 'HomeStudentDashboardView',
  components: {
    'modal-student-info-view': ModalStudentInfoView,
    'modal-student-simulator-view': ModalStudentSimulatorView,
  },
  extends: HomeStudentDashboardComponent,
  data() {
    return {
      // Portadas de curso que fallaron al cargar (fichero ausente en /uploads)
      failedCovers: [],
    };
  },
  methods: {
    onCoverError(courseId) {
      if (!this.failedCovers.includes(courseId)) {
        this.failedCovers.push(courseId);
      }
    },
    hasCover(courseId) {
      return !this.failedCovers.includes(courseId);
    },
  },
};
</script>

<template>
  <div class="home-student-view">
    <!-- Encabezado de página estilo Appmisionate con botón de acción Crear Simulador -->
    <div class="stream_page_header">
      <div class="stream_header_left">
        <div class="stream_header_icon">
          <i class="fas fa-th-large" />
        </div>
        <div class="stream_header_text">
          <h4 class="item_title">
            Resumen
          </h4>
          <p class="stream_header_subtitle">
            Bienvenido a tu panel de estudio. Revisa tus avances, métricas y cursos activos.
          </p>
        </div>
      </div>
      <div class="stream_header_right">
        <button
          type="button"
          class="account_btn_primary"
          @click="onCreateSimulator"
        >
          <i class="fas fa-plus-circle" /> Crear Simulador
        </button>
      </div>
    </div>

    <!-- Cuadrícula de estadísticas -->
    <div
      v-if="currentStats"
      class="account_stats_grid"
    >
      <div class="account_stat_card">
        <div class="account_stat_icon is_blue">
          <i class="fas fa-star" />
        </div>
        <div class="account_stat_body">
          <span class="account_stat_value">{{ currentStats.totalFavorite }}</span>
          <span class="account_stat_label">Cursos Favoritos</span>
        </div>
      </div>

      <div class="account_stat_card">
        <div class="account_stat_icon is_green">
          <i class="fas fa-thumbs-up" />
        </div>
        <div class="account_stat_body">
          <span class="account_stat_value">{{ currentStats.totalLiked }}</span>
          <span class="account_stat_label">Te Gustan</span>
        </div>
      </div>

      <div class="account_stat_card">
        <div class="account_stat_icon is_red">
          <i class="fas fa-thumbs-down" />
        </div>
        <div class="account_stat_body">
          <span class="account_stat_value">{{ currentStats.totalDisliked }}</span>
          <span class="account_stat_label">No Te Gustan</span>
        </div>
      </div>

      <div class="account_stat_card">
        <div class="account_stat_icon is_navy">
          <i class="fas fa-crown" />
        </div>
        <div class="account_stat_body">
          <span
            class="account_stat_value"
            style="font-size: 1.1rem; line-height: 1.3;"
          >
            {{ currentStats.endDateSubscription ? formatDate(currentStats.endDateSubscription) : 'Sin Inscripción' }}
          </span>
          <span class="account_stat_label">Fin de Suscripción</span>
        </div>
      </div>
    </div>

    <!-- Sección: Cursos Activos -->
    <div class="dash_section_header">
      <div class="dash_section_title">
        <i class="fas fa-book-reader" /> Cursos Activos
        <span
          v-if="currentCourses && currentCourses.length > 0"
          class="dash_section_count"
        >
          {{ currentCourses.length }}
        </span>
      </div>
      <router-link
        to="/estudiante/cursos"
        class="dash_section_link"
      >
        Ver todos los cursos <i class="fas fa-arrow-right" />
      </router-link>
    </div>

    <div
      v-if="currentCourses && currentCourses.length > 0"
      class="row dash_courses_row"
    >
      <div
        v-for="course in currentCourses"
        :key="course.id"
        class="col-xl-3 col-lg-4 col-md-6 col-12 d-flex"
      >
        <div class="dash_course_card dash_course_card--wide mb-30">
          <div class="dash_course_thumb">
            <router-link :to="'/estudiante/cursos/' + course.id + '/detalles'">
              <img
                v-if="hasCover(course.id)"
                :src="getCoverImage(course.coverImageUrl)"
                :alt="course.title"
                loading="lazy"
                @error="onCoverError(course.id)"
              >
              <div
                v-else
                class="dash_course_thumb_fallback"
              >
                <i class="far fa-book-open" />
              </div>
              <div
                v-if="course.totalHours"
                class="dash_course_duration"
              >
                <i class="far fa-clock" /> {{ course.totalHours }} Horas
              </div>
              <div class="dash_course_play">
                <i class="fas fa-play" />
              </div>
            </router-link>
          </div>

          <div class="dash_course_body">
            <div class="dash_course_meta">
              <span class="dash_course_views">
                <i class="far fa-eye" /> {{ course.totalViewed || 0 }} vista(s)
              </span>
              <button
                type="button"
                class="dash_course_like_btn"
                :class="{ active: course.isLiked }"
                title="Me gusta"
                @click="onDoLike(course)"
              >
                <i :class="course.isLiked ? 'fas fa-heart' : 'far fa-heart'" />
              </button>
            </div>

            <router-link
              :to="'/estudiante/cursos/' + course.id + '/detalles'"
              class="dash_course_title"
              :title="course.title"
            >
              {{ course.title }}
            </router-link>

            <span
              v-if="course.tags"
              class="dash_course_tag"
            >
              {{ mapTags(course.tags) }}
            </span>

            <div class="dash_course_footer">
              <span
                v-if="course.author"
                class="dash_course_author"
              >
                Por <strong>{{ course.author }}</strong>
              </span>
              <router-link
                :to="'/estudiante/cursos/' + course.id + '/detalles'"
                class="dash_course_action"
              >
                Continuar <i class="fas fa-chevron-right" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Estado vacío: Sin cursos activos -->
    <div
      v-else
      class="stream_empty_state"
    >
      <div class="stream_empty_icon">
        <i class="fas fa-book-open" />
      </div>
      <h4>Aún no estás inscrito en ningún curso activo</h4>
      <p>Explora nuestro catálogo completo de cursos y prepárate con los mejores contenidos.</p>
      <router-link
        to="/estudiante/cursos"
        class="account_btn_primary mt-3"
      >
        <i class="fas fa-search" /> Explorar Cursos
      </router-link>
    </div>

    <!-- Sección: Cursos Finalizados -->
    <div class="dash_section_header">
      <div class="dash_section_title">
        <i class="fas fa-graduation-cap" /> Cursos Finalizados
        <span
          v-if="finishedCourses && finishedCourses.length > 0"
          class="dash_section_count"
        >
          {{ finishedCourses.length }}
        </span>
      </div>
    </div>

    <div
      v-if="finishedCourses && finishedCourses.length > 0"
      class="row dash_courses_row"
    >
      <div
        v-for="course in finishedCourses"
        :key="course.id"
        class="col-xl-3 col-lg-4 col-md-6 col-12 d-flex"
      >
        <div class="dash_course_card dash_course_card--wide mb-30">
          <div class="dash_course_thumb">
            <router-link :to="'/estudiante/cursos/' + course.id + '/detalles'">
              <img
                v-if="hasCover(course.id)"
                :src="getCoverImage(course.coverImageUrl)"
                :alt="course.title"
                loading="lazy"
                @error="onCoverError(course.id)"
              >
              <div
                v-else
                class="dash_course_thumb_fallback"
              >
                <i class="far fa-book-open" />
              </div>
              <div
                v-if="course.totalHours"
                class="dash_course_duration"
              >
                <i class="far fa-clock" /> {{ course.totalHours }} Horas
              </div>
              <div class="dash_course_play">
                <i class="fas fa-play" />
              </div>
            </router-link>
          </div>

          <div class="dash_course_body">
            <div class="dash_course_meta">
              <span class="dash_course_views">
                <i class="far fa-eye" /> {{ course.totalViewed || 0 }} vista(s)
              </span>
              <button
                type="button"
                class="dash_course_like_btn"
                :class="{ active: course.isLiked }"
                title="Me gusta"
                @click="onDoLike(course)"
              >
                <i :class="course.isLiked ? 'fas fa-heart' : 'far fa-heart'" />
              </button>
            </div>

            <router-link
              :to="'/estudiante/cursos/' + course.id + '/detalles'"
              class="dash_course_title"
              :title="course.title"
            >
              {{ course.title }}
            </router-link>

            <span
              v-if="course.tags"
              class="dash_course_tag"
            >
              {{ mapTags(course.tags) }}
            </span>

            <div class="dash_course_footer">
              <span
                v-if="course.author"
                class="dash_course_author"
              >
                Por <strong>{{ course.author }}</strong>
              </span>
              <router-link
                :to="'/estudiante/cursos/' + course.id + '/detalles'"
                class="dash_course_action"
              >
                Repasar <i class="fas fa-chevron-right" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Estado vacío: Sin cursos finalizados -->
    <div
      v-else
      class="stream_empty_state"
    >
      <div class="stream_empty_icon">
        <i class="fas fa-award" />
      </div>
      <h4>Aún no has completado cursos</h4>
      <p>Continúa avanzando en tus cursos activos para ver tus logros y certificados aquí.</p>
    </div>

    <!-- Modales de soporte -->
    <modal-student-info-view
      v-if="modalSubscriptionInfo.isVisible"
      :form-data="studentInfoItem"
      :conf="modalSubscriptionInfo"
    />
    <modal-student-simulator-view
      v-if="modalSimulatorInfo.isVisible"
      :form-data="studentSimulatorItem"
      :conf="modalSimulatorInfo"
    />
  </div>
</template>
